module.exports = __webpack_public_path__ + "img/logo.2edfabe4.svg";